var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgAdd({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#384a5f",
    d: "M256 0C114.844 0 0 114.844 0 256s114.844 256 256 256 256-114.844 256-256S397.156 0 256 0zm149.333 266.667a10.66 10.66 0 01-10.667 10.667H277.333v117.333a10.66 10.66 0 01-10.667 10.667h-21.333a10.66 10.66 0 01-10.667-10.667V277.333H117.333a10.66 10.66 0 01-10.667-10.667v-21.333a10.66 10.66 0 0110.667-10.667h117.333V117.333a10.66 10.66 0 0110.667-10.667h21.333a10.66 10.66 0 0110.667 10.667v117.333h117.333a10.66 10.66 0 0110.667 10.667v21.334z"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdd);
export default __webpack_public_path__ + "static/media/add.4d8747e77497c5d80d864939fd4c4256.svg";
export { ForwardRef as ReactComponent };